export const getSuggestionGroups = state => state.suggestionGroups;
